const $ = require('jquery'),
    maps = require('../includes/google-maps.js'),
    GoogleMaps = require('../../../global/js/modules/google-maps'),
    VueUtils = require('../modules/vue-utils'),
    Tracker = require('../../../global/js/modules/google-analytics')
;

let $form,
    $featureWrapper;

// Result of Google Maps promise
let mapIsBeingSetup = null; //this will hold the promise for setting up the map
let mapIsSetup = null; //true for success, false for failed
let mapSetupResult = null; //result from setting map up

//region Setup Google Maps Helpers
function _populateMapMarkers(map) {

    const method = `launchpadCallback${(new Date).getTime()}`;

    window[method] = (method, value, caller) => {
        switch (method) {
            case 'location':
            case 'pickup':
                VueUtils.getRef('vehicle-type-filter').selectLocation(value);
                // maps.closeMap();
                break;
        }
    };

    map._markers = [];

    let activeInfoWindow = null;

    return new Promise((resolve, reject) => {
        const bounds = new google.maps.LatLngBounds();
        const $coordinateElements = document.querySelectorAll('[type="text/gps-coordinates"]');

        if ($coordinateElements.length === 0) {
            reject('No location coordinates found.');
        }

        const buttonsMarkup = '<div class="actions">' +
            `<button class="button set-location-button set-location _selected_ map-toggle-_value_" onclick="${method}('location', '_value_', this)">
                <span class="unselect">
                    <i class="fas fa-times mr-1"></i>
                    Location Set
                </span>
                <span class="select">
                    Set location
                </span>
            </button>` +
            '</div>';

        for (let $coordElement of $coordinateElements) {
            const coordinate = JSON.parse($coordElement.innerText);

            if (!coordinate || !coordinate.lat || !coordinate.lng) {
                continue;
            }

            $coordElement._infoWindow = new google.maps.InfoWindow({content: 'not yet initialized'});

            $coordElement._marker = new google.maps.Marker({
                position: coordinate,
                map: map,
            });
            $coordElement._marker.addListener('click', () => {
                if (activeInfoWindow) {
                    activeInfoWindow.close();
                    activeInfoWindow = null;
                }
                $coordElement._infoWindow.setContent(`<strong>${coordinate.title}</strong><br>${coordinate.address.join('<br>')}` +
                    buttonsMarkup
                    .replace(/_value_/g, coordinate.slug)
                    .replace(/_selected_/g, (VueUtils.getRef('vehicle-type-filter').selectedValues.locations || []).indexOf(coordinate.slug) >= 0 ? 'selected' : '')
                );
                $coordElement._infoWindow.open(map, $coordElement._marker);
                activeInfoWindow = $coordElement._infoWindow;
            });

            $coordElement._marker.$coordElement = $coordElement;
            $coordElement._marker.setMap(map);
            map._markers.push($coordElement._marker);

            $coordElement._marker._index = map._markers.length - 1;

            bounds.extend($coordElement._marker.getPosition());
        }

        map.fitBounds(bounds);

        resolve();
    });
}

function _getClosestMarker(map, coords) {
    let target = map._markers.reduce(function (previous, current) {
        let distanceA = google.maps.geometry.spherical.computeDistanceBetween(coords, current.position),
            distanceB = google.maps.geometry.spherical.computeDistanceBetween(coords, previous.position);

        return distanceA < distanceB ? current : previous;

    });

    if (target) {
        // target.setAnimation(google.maps.Animation.BOUNCE);
        new google.maps.event.trigger(target, 'click');
    }

    return target;
}

const searchBoundsPadding = 135;
let animatingMarker = null;

function _clearAnimatedMarker() {


    if (animatingMarker) {
        animatingMarker.setAnimation(null);
        animatingMarker.setMap(null);
        animatingMarker = null;
    }
}

function _bindGeocodingToInput($input, map) {
    if (!$input) {
        return;
    }

    const geocoder = GoogleMaps.geocoder();
    const $searchContainer = $input.parentNode;

    $input.addEventListener('keyup', (event) => {
        if (event.keyCode === 13) {
            $searchContainer.classList.add('searching');
            $input.disabled = true;

            let query = {
                componentRestrictions: {
                    country: 'AU',
                },
            };

            if (/[^0-9]/g.test($input.value)) {
                query.address = $input.value;
            }
            else {
                query.address = `${$input.value}, Australia`;
                query.componentRestrictions.postalCode = $input.value;
            }

            _clearAnimatedMarker();

            geocoder.geocode(query, (results, status) => {
                if (status === 'OK') {
                    let coords = results[0].geometry.location;

                    let target = _getClosestMarker(map, coords);

                    animatingMarker = new google.maps.Marker({
                        position: coords,
                        map: map,
                    });

                    animatingMarker.setAnimation(google.maps.Animation.BOUNCE);

                    const bounds = new google.maps.LatLngBounds();
                    bounds.extend(coords);
                    bounds.extend(target.position);

                    // map.panTo(target ? target.position : coords);
                    // map.setZoom(18);

                    map.fitBounds(bounds, {
                        bottom: searchBoundsPadding,
                        left: searchBoundsPadding / 2,
                        right: searchBoundsPadding / 2,
                        top: searchBoundsPadding,
                    });
                }
                else {
                    alert('Error during search. Please check address and try again.');
                }

                $input.disabled = false;
                $searchContainer.classList.remove('searching');
            });
        }
    })
}

function _bindUserLocationToButton($button, map) {
    if (!navigator.geolocation || !/^https/.test(document.location.href)) {
        $button.parentNode.removeChild($button);
        return;
    }

    $button.addEventListener('click', event => {
        $button.disabled = true;
        navigator.geolocation.getCurrentPosition(position => {
            let coords = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

            let target = _getClosestMarker(map, coords);

            _clearAnimatedMarker();

            animatingMarker = new google.maps.Marker({
                position: coords,
                map: map,
            });

            animatingMarker.setAnimation(google.maps.Animation.BOUNCE);

            // map.panTo(target ? target.position : coords);
            // map.setZoom(18);

            const bounds = new google.maps.LatLngBounds();
            bounds.extend(coords);
            bounds.extend(target.position);

            map.fitBounds(bounds, {
                bottom: searchBoundsPadding,
                left: searchBoundsPadding / 2,
                right: searchBoundsPadding / 2,
                top: searchBoundsPadding,
            });

            $button.disabled = false;
        }, error => {
            alert('Unable to determine location. Please try entering your postcode or suburb.');
            console.error('error getting post', error);
            $button.disabled = false;
        });
    });

}
//endregion Setup Google Maps Helpers

//region Google Maps Init
function _setupMap() {

    // Did we do this before? return that result instead
    if (mapIsSetup !== null) {
        return new Promise((resolve, reject) => {
            if (mapIsSetup) {
                //if it was success, resolve
                resolve(mapSetupResult);
            } else {
                //otherwise reject
                reject(mapSetupResult);
            }
        });
    }

    // If the map is already being setup, return that promise instead
    if (mapIsBeingSetup !== null) {
        return mapIsBeingSetup;
    }

    let $mapContainer = document.querySelector('.featureMap__mapFrame');

    if (!$mapContainer) {
        return;
    }

    let mapResponse = null;

    maps.setCloseCallback(() => {
        //force false..
        //@todo assess if any events should be fired from this state...
        VueUtils.getRef('vehicle-type-filter').mapToggled = false;
    });

    // Save the entire google maps promise to not have multiple google maps init on mobile
    // and to make sure there's not multiple markers on search or multiple error messages on failed search
    return mapIsBeingSetup = new Promise((resolve, reject) => {

        GoogleMaps.insertMap($mapContainer, {
            center: {lat: -34.9285873, lng: 138.6006675},
            zoom: 21,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
        }, {}, ['geometry'])

        .then(map => {
            mapIsSetup = true;
            mapSetupResult = map;

            return new Promise((resolve, reject) => {
                //this timeout is to prevent the tracker not being available when this is fired...
                //bit naive, but adding retry/catch-then-log to the tracker will require more time
                //than is available right now
                window.setTimeout(() => {
                    Tracker.track(
                        'Google Map',
                        'Load',
                        'Booking Launchpad'
                    );
                }, 2000);
                resolve(map);
            });
        })
        .then(map => {
            mapResponse = map;

            _bindGeocodingToInput($mapContainer.parentNode.querySelector('input[name=search]'), map);
            _bindUserLocationToButton($mapContainer.parentNode.querySelector('button.use-my-location'), map);
            return _populateMapMarkers(map);
        }, error => console.log(`Error injecting map: ${error}`))
        .then(() => {
            document.querySelector('body').classList.add('map-injected');
            resolve(mapResponse);
        }, error => {
            console.log(`Error populating markers: ${error}`);

            mapIsSetup = false;
            mapSetupResult = error;
        });
    });
}

function _dealWithTabChanges() {
    $('.itineraryTabGroup')
    .on('tab-change', (event, $tabButton) => {
        if ($tabButton.classList.contains('tabButton--reservation') && $featureWrapper.classList.contains('map-open')) {
            maps.closeMap();
        }
    })
    ;
}
//endregion Google Maps Init

function _setupForVueApp() {
    if ($form.querySelectorAll('.v-app').length === 0) {
        return;
    }

    $form.addEventListener('vehicle-type-filter:selected-location', event => {
        if (!event.detail.selectedLocations) {
            return;
        }

        for (const $el of $featureWrapper.querySelectorAll('button.set-location.selected')) {
            $el.classList.remove('selected');
        }

        for (const slug of event.detail.selectedLocations) {
            const $el = $featureWrapper.querySelector(`button.set-location.map-toggle-${slug}`);
            //button may not be visible if the info window is dismissed
            if (!$el) {
                continue;
            }
            $el.classList.add('selected');
        }
    });

    $form.addEventListener('vehicle-type-filter:map-visibility-toggled', event => {

        // open map will add all the classes and styling for google maps.
        // It's necessary to start this first to add the loading screen
        if (event.detail.mapToggled) {

            maps.openMap();

            // Create a Google Maps object when opening the map
            // This will save the Gmaps promise to only create a single object per load
            _setupMap();
        }
        else {
            maps.closeMap();
        }
    });

    // $form.addEventListener('vehicle-type-filter:selected-vehicle-type', event => {
    //     $form.querySelector('.bookingForm__submit').disabled = event.detail.selectedVehicles.length === 0;
    // });
}

function _setupLocationCountTracking($form) {
    $form.addEventListener('submit', event => {

        const $locationSlugsInput = $form.querySelector('[name^="location_slugs"]');

        if (!$locationSlugsInput) {
            console.warn('Unable to determine location field.');
            return;
        }

        const selectedOptions = $locationSlugsInput.querySelectorAll('option[selected]');

        if (selectedOptions.length === 0) {
            console.warn('Form submission with no locations selected?');
            return;
        }

        Tracker.track(
            'Homepage Booking Launchpad',
            'Vehicle Search',
            selectedOptions.length > 1 ? 'Multiple Locations' : 'Single Location'
            );
    });
}

function _init() {

    $featureWrapper = document.querySelector('#featureWrap');

    $form = document.querySelector('html.home div.make-booking form');

    if (!$form) {
        return;
    }

    _setupForVueApp();

    // Setup event listener for tab changes
    _dealWithTabChanges();

    _setupLocationCountTracking($form);
}

if (document.querySelector('html.home')) {
    document.addEventListener('DOMContentLoaded', _init);
}
